import React from 'react';
import { useContext, useEffect } from "react";
import Typography from '@material-ui/core/Typography';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import CircularProgress from '@material-ui/core/CircularProgress';
import useAxios from 'axios-hooks';
import { Language } from "../languages"
import { LanguageContext, Complexity, ComplexityOverride } from "../Helpers/Context";

export default function ComplexityList() {
    const { language, dictionary, complexity, setComplexity, setComplexityOverride, complexityOverride, officeId } = useContext(LanguageContext);

    const handleListItemClick = (
        item: Complexity,
    ) => {
        setComplexity(item);
    };

    const [{ data, loading }] = useAxios<Complexity[]>(
        "Complexity?taxEngineId=1"
    );

    const [{ data: dataOverride, loading: loadingOverride }] = useAxios<ComplexityOverride[]>(
        `Complexity/Override?officeId=${officeId}`
    );

    useEffect(() => {
        // Update override when officeId or selected complexity changes
        if (dataOverride && !loadingOverride && complexity) {
            let override = dataOverride?.find(x => x.billingId === complexity.billingId && x.rowStatus === "A");
            setComplexityOverride(override);
        }
    }, [dataOverride, loadingOverride, complexity, setComplexityOverride, officeId]);

    useEffect(() => {
        //Update override info when a Post happens (complexityOverride object was changed)
        if (dataOverride && !loadingOverride && complexityOverride && complexityOverride.officeId === officeId) {

            let objIndex = dataOverride.findIndex((obj => obj.billingId === complexityOverride?.billingId));

            if (objIndex >= 0) {
                if (dataOverride[objIndex].amount !== complexityOverride.amount ||
                    dataOverride[objIndex].rowStatus !== complexityOverride.rowStatus) {
                    // only update existing when there is a change
                    dataOverride[objIndex].amount = complexityOverride.amount;
                    dataOverride[objIndex].rowStatus = complexityOverride.rowStatus;
                }
            }
            else {
                dataOverride.push(complexityOverride);
            }
        }
    }, [dataOverride, loadingOverride, complexityOverride, officeId]);

    return (
        <React.Fragment>
            <Typography variant="h6" color="primary">
                {dictionary.complexityListTitle}
            </Typography>
            {(loading || loadingOverride) && (
                <CircularProgress />
            )}
            {data && !loading && !loadingOverride && (
                <List >
                    {data?.map((item) =>
                    (
                        <ListItem
                            key={item.complexityId}
                            button
                            selected={complexity?.complexityId === item.complexityId}
                            onClick={() => handleListItemClick(item)}
                        >
                            <ListItemText primary={language === Language.English ? item.description : item.descriptionFr} />
                        </ListItem>
                    ))}
                </List>
            )}
        </React.Fragment>
    );
}